import { render, staticRenderFns } from "./Photos.vue?vue&type=template&id=86cf67b4&scoped=true&"
var script = {}
import style0 from "./Photos.vue?vue&type=style&index=0&id=86cf67b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cf67b4",
  null
  
)

export default component.exports